import React from 'react';
import classNames from 'classnames';
import { Typography } from '../../typography/typography';
import { notNil } from '../../../core/helpers/is-nil';
import styles from './pagination-number.module.scss';

type Props = {
  children: string;
  active?: boolean;
  onClick?: () => void;
};

export const PaginationNumber: React.FC<Props> = ({ children, active = false, onClick }) => {
  const isClickable = notNil(onClick);

  return (
    <button
      className={classNames(styles.root, { [styles.active]: active, [styles.clickable]: isClickable })}
      onClick={onClick}
    >
      <Typography variant="maintext">{children}</Typography>
    </button>
  );
};
